import { AI_CHART_URL } from "apiHandler/iFrameUrl";
import { useUserData } from "components/customHooks/userDataContext";
import React, { useEffect, useRef } from "react";

const ACCUCHART_ORIGIN = AI_CHART_URL;
const IFRAME_URL = `${ACCUCHART_ORIGIN}/answering-service/analytics`;

const CallDashboardFrame = () => {
  const iframeRef = useRef(null);

  const userData = useUserData();

  const token = userData?.access_token;
  const practiceId = userData?.selected_practice;
  const isIframeReadyRef = useRef(false);

  const sendTokenToIframe = () => {
    if (!iframeRef.current?.contentWindow || !token) return;
    if (!isIframeReadyRef.current) return;

    iframeRef.current.contentWindow.postMessage(
      {
        type: "AccuChart:setAuthToken",
        token,
        practice_id: practiceId,
      },
      ACCUCHART_ORIGIN,
    );
  };

  useEffect(() => {
    const handleLoad = () => {
      sendTokenToIframe();
    };

    const iframe = iframeRef.current;

    iframe?.addEventListener("load", handleLoad);

    return () => {
      iframe?.removeEventListener("load", handleLoad);
    };
  }, []);

  useEffect(() => {
    if (isIframeReadyRef.current) {
      sendTokenToIframe();
    }
  }, [token, practiceId]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== ACCUCHART_ORIGIN) return;

      if (
        event.data?.type === "AccuChart:ready" ||
        event.data?.type === "AccuChart:requestAuthToken"
      ) {
        isIframeReadyRef.current = true;
        sendTokenToIframe();
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    const handleLogout = () => {
      const iframe = iframeRef.current;
      if (!iframe?.contentWindow) return;

      isIframeReadyRef.current = false;

      iframe.contentWindow.postMessage(
        { type: "AccuChart:logout" },
        ACCUCHART_ORIGIN,
      );
    };
    window.addEventListener("accuchart-logout", handleLogout);

    return () => {
      window.removeEventListener("accuchart-logout", handleLogout);
    };
  }, []);
  return (
    <iframe
      ref={iframeRef}
      src={IFRAME_URL}
      title="AI Chart Dictations"
      width="100%"
      height="100%"
      style={{
        border: "none",
        minHeight: "100vh",
      }}
      allow="microphone"
    />
  );
};

export default CallDashboardFrame;
